
function debounce(func: () => void, time: number = 100):any {
    let timer: number | undefined;
    return function (event: any) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}


export function onResize(func: () => void, time: number = 100): any {
    window.addEventListener("resize", debounce(func, time));
}



